import { render, staticRenderFns } from "./subsequent-activities.vue?vue&type=template&id=04baf927&"
import script from "./subsequent-activities.vue?vue&type=script&lang=js&"
export * from "./subsequent-activities.vue?vue&type=script&lang=js&"
import style0 from "./subsequent-activities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports